<script>
  import Braintree from './Braintree.svelte';
  import { M } from '../../external';
  import { createEventDispatcher, onMount } from 'svelte';
  import PayPalViaBraintree from './PayPalViaBraintree.svelte';
  import AuthorizeNet from './AuthorizeNet.svelte';
  import LegacyStripe from './LegacyStripe.svelte';
  import Stripe from './Stripe.svelte';
  import Paystack from './Paystack.svelte';
  import Payfast from './Payfast.svelte';

  export let settings, billingInfo, amount, futureAmount, currency, inCheckout;

  export const onAmountChange = () => {
    if (instance) {
      instance.onAmountChange();
    }
  };

  export const completeRequiredPaymentActions = async () => {
    if (instance && instance.completeRequiredPaymentActions) {
      return instance.completeRequiredPaymentActions();
    }
  };

  export const completeRequiredSetupActions = async () => {
    if (instance && instance.completeRequiredSetupActions) {
      return instance.completeRequiredSetupActions();
    }
  };

  let dispatch = createEventDispatcher();

  let instance;
  let editing = false;

  export const getPaymentDetails = async (billingInfo) => {
    if (instance) {
      return await instance.getPaymentDetails(billingInfo);
    }
    return {};
  };

  export const cancelEdits = () => {
    editing = false;
  };

  let onEdit = () => {
    editing = true;
    dispatch('edit');
  };

  onMount(() => {
    if (!billingInfo?.cardType) {
      onEdit();
    }
  });

  $:cardType = billingInfo?.cardType?.toLowerCase().replace(/[^a-z]/g, '');
</script>

{#if editing}
  {#if settings.type === 'braintree'}
    <Braintree bind:this={instance} {amount} {futureAmount} {currency} {settings} />
  {:else if settings.type === 'paypal-bt'}
    <PayPalViaBraintree bind:this={instance} {amount} {futureAmount} {currency} {settings} />
  {:else if settings.type === 'authorize.net'}
    <AuthorizeNet bind:this={instance} {amount} {futureAmount} {currency} {settings} />
  {:else if settings.type === 'stripe'}
    <LegacyStripe bind:this={instance} {amount} {futureAmount} {currency} {settings} />
  {:else if settings.type === 'stripe-connect'}
    <Stripe bind:this={instance} {amount} {futureAmount} {currency} {settings} />
  {:else if settings.type === 'paystack'}
    <Paystack bind:this={instance} {amount} {futureAmount} {currency} {settings} {inCheckout} />
  {:else if settings.type === 'payfast'}
    <Payfast bind:this={instance} {amount} {futureAmount} {currency} {settings} {inCheckout} />
  {:else}
    <!-- unsupported -->
    <span class="red white mt-15 mb-15 f-left" style="padding: 15px">Unsupported payment processor</span>
  {/if}
{:else}
  <label data-name="paymentMethodInfo" class="f-left col20 clear-both">
    <span>{M.PAYMENT_METHOD}</span>
    <div class="col20 f-left">
      {#if cardType === 'paypal'}
        <h3>{billingInfo.paypalEmail}</h3>
      {:else if cardType === 'payfast'}
        <h3>Payfast</h3>
      {:else if billingInfo.bin || billingInfo.lastTwo}
        <h3>{billingInfo.bin || '**'}********{billingInfo.lastTwo || '**'}</h3>
      {:else}
        <h3>-</h3>
      {/if}
      <span class="payment-type {cardType}"></span>
    </div>
    {#if !inCheckout || amount > -0.001}
      <!-- not possible to change payment method for refunds -->
      <div class="col20 f-left mt-10">
        <a on:click={onEdit} class="blue-text lowercase">{M.EDIT_PAYMENT}</a>
      </div>
    {/if}
  </label>
{/if}
